import React from "react";
import screenfull from "screenfull";
import { useLocation } from "react-router-dom";
import "../App.scss";
import "./Header.scss";
import useMousetrap from "react-hook-mousetrap";
import YarraTramsLogo from "../images/Logos/yarra-trams.svg";
import PTVLogo from "../images/Logos/ptv.svg";
import { ReactComponent as SettingsIcon } from "../images/Icons/settings.svg";
import { ReactComponent as SquareIcon } from "../images/Icons/square.svg";
import { ReactComponent as ScreenRotationIcon } from "../images/Icons/screen_rotation-white-36dp.svg";
import { useAuth } from "../Context/Auth";

function Branding() {
  return (
    <div className="branding">
      <img className="logo-yt" src={YarraTramsLogo} alt="Yarra Tram" />
      <img className="logo-ptv" src={PTVLogo} alt=">PTV" />
    </div>
  );
}

function StopName(props) {
  const stop = props.stop;

  const content = stop ? (
    <div className="stop-name">
      <h1>
        Stop {stop.FlagStopNo}: {stop.StopName}
      </h1>
    </div>
  ) : null;

  return content;
}

function StopDirection(props) {
  const stop = props.stop;

  if (stop && stop.platforms && Array.isArray(stop.platforms)) {
    return <div className="stop-direction-wrapper"></div>;
  } else {
    return null;
  }
}

function ControlPanel() {
  const location = useLocation();
  const { isPortrait, setIsPortrait } = useAuth();

  useMousetrap(
    "f",
    () => {
      goFullscreen();
    },
    "keyup"
  );

  function goFullscreen(e) {
    if (e) {
      e.preventDefault();
    }
    if (screenfull.isEnabled) {
      screenfull.toggle();
    } else {
      throw new Error("Fullscreen is not supported");
    }
  }

  function goSettingPage(e) {
    if (e) {
      e.preventDefault();
    }
    window.location = "/settings" + location.search;
  }

  function rotateScreen(e) {
    if (e) {
      e.preventDefault();
    }
    setIsPortrait(!isPortrait);
  }

  return (
    <div className="control-panel d-flex position-absolute d-flex align-items-center flex-column justify-content-center">
      <a
        className="go-settings-btn custom-btn d-flex align-items-center"
        href="/#"
        onClick={goSettingPage}
      >
        <SettingsIcon className="settings-icon" />
      </a>
      <a
        className="fullscreen-btn custom-btn d-flex align-items-center"
        href="/#"
        onClick={goFullscreen}
      >
        <SquareIcon className="fullscreen-icon" />
      </a>
      <a
        className="rotate-screen-btn custom-btn d-flex align-items-center"
        href="/#"
        onClick={rotateScreen}
      >
        <ScreenRotationIcon className="rotation-icon" />
      </a>
    </div>
  );
}

export { Branding, StopName, StopDirection, ControlPanel };
